module.exports = __webpack_public_path__ + "img/cbt_btn.3bb74bdf.png";